import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import LogoCaxias from '../../../../assets/img/pngCaxiasLogo.png'
import { PreloaderRingMin } from '../../../../components/Preloder/Preloader'
import { baseURL } from '../../../../config/baseURL'


export default function Relacao_Socios() {


    const dispatch = useDispatch()
    dispatch({ type: 'UPDATE_RELAC_ANIVERSARIANTES' })

    const [preloadRingMin, setPreloadRingMin] = useState('d-none')
    const [arrayDados, setArrayDados] = useState([])
    const [mes, setMes] = useState('00')
    const [areaFiltro, setAreaFiltro] = useState(' col-md-6 rounded-lg border border-danger mb-3 pt-3')
    const [areaLogo, setAreaLogo] = useState('row align-items-center justify-content-center d-none')
    const [areaDadosRel, setAreaDadosRel] = useState('container-fluid  rounded-lg border border-danger mb-3 pt-3')
    const [classAlertBuscSocio, setclassAlertBuscSocio] = useState('alert alert-danger form-group col-md-12 mt-5 d-none')
    const [msgAlert, setmsgAlert] = useState('')
    const [btnImprimir, setBtnImprimir] = useState('btn btn-dark mx-3 d-none')

    async function gerarRelatorio() {
        setPreloadRingMin('d-block')
        setBtnImprimir('btn btn-dark mx-3 d-none')
        setArrayDados([])

        if (mes === '00') {
            setPreloadRingMin('d-none')
            setmsgAlert('Selecione o mês para gerar o relatório.')
            return setclassAlertBuscSocio('mt-n2 alert alert-danger form-group col-md-12 mt-5 d-block text-left')

        }

        const response = await fetch(baseURL + `aniver-mes-relatorio?mes=${mes}`, {
            method: 'GET',
            mode: 'cors',
            headers: {
                "authorization": `Bearer ${localStorage.getItem('token')}`
            }
        })

        const respJSON = await response.json()

        if (respJSON.erro) {
            setPreloadRingMin('d-none')
            setmsgAlert(respJSON.erro)
            return setclassAlertBuscSocio('mt-n2 alert alert-danger form-group col-md-12 mt-5 d-block text-left')
        }

        setBtnImprimir('btn btn-dark mx-3')
        setPreloadRingMin('d-none')
        setmsgAlert('Relatório gerado com sucesso.')
        setclassAlertBuscSocio('mt-n2 alert alert-success form-group col-md-12 mt-5 d-block text-left')
        //   setAreaFiltro('container-fluid  rounded-lg border border-danger mb-3 pt-3 d-none')
        setArrayDados(respJSON)
    }

    async function imprimirRel() {
        await dispatch({ type: 'UPDATE_DISPLAY_N' })
        await setAreaFiltro('container-fluid  rounded-lg border border-danger mb-3 pt-3 d-none')
        await setAreaLogo('row align-items-center justify-content-center')
        await setAreaDadosRel('container-fluid  rounded-lg mb-3 pt-3')

        window.print()

        await dispatch({ type: 'UPDATE_DISPLAY_B' })
        await setAreaLogo('row align-items-center justify-content-center d-none')
        await setAreaFiltro(' col-md-6 rounded-lg border border-danger mb-3 pt-3')
        await setAreaDadosRel('container-fluid  rounded-lg border border-danger mb-3 pt-3')
    }

    return (
        <div className="container-fluid text-center mt-n3">
            <div className={areaLogo}>
                <div className="col-md-2 ">
                    <img src={LogoCaxias} className='ml-5 img-fluid' alt="" />
                </div>
                <div className="col-md-6">
                    <div className="row">
                        <div className="col-md-12">
                            <h1>CAXIAS ESPORTE CLUBE</h1>
                        </div>
                        <div className="col-md-12">
                            <h4>FUNDADO EM 06 DE SETEMBRO DE 1940</h4>
                        </div>
                    </div>
                </div>
            </div>

            {/*AREA DOS FILTROS*/}
            <div className={areaFiltro}>
                <div className="row justify-content-start mb-3">
                    <div className="col-md-auto mr-n4"> <h5>Filtros do Relatório</h5> </div>
                    <div className="col-md-auto"><i className={preloadRingMin} ><PreloaderRingMin /></i></div>
                </div>
                <div className="form-row">
                    <div className="form-group col-md-8 text-left">
                        <label htmlFor="ordemRel">Mês de Aniversário</label>
                        <select id="ordemRel" className="form-control" value={mes} onChange={event => setMes(event.target.value)} >
                            <option value="00">Escolha...</option>
                            <option value="01">Janeiro</option>
                            <option value="02">Fevereiro</option>
                            <option value="03">Março</option>
                            <option value="04">Abril</option>
                            <option value="05">Maio</option>
                            <option value="06">Junho</option>
                            <option value="07">Julho</option>
                            <option value="08">Agosto</option>
                            <option value="09">Setembro</option>
                            <option value="10">Outubro</option>
                            <option value="11">Novembro</option>
                            <option value="12">Dezembro</option>
                        </select>
                    </div>

                    <div className={classAlertBuscSocio} role="alert" >
                        <strong> {msgAlert}</strong>
                    </div>
                    <div className="form-group col-md-12 text-left">
                        <button onClick={gerarRelatorio} className="btn btn-secondary" type="button">Gerar</button>
                        <button onClick={imprimirRel} className={btnImprimir} type="button">  <i className="fas fa-print"></i> </button>
                    </div>
                </div>
            </div>

            {/*AREA DOS DADOS DO RELATORIO*/}
            <div id="bodyBusc" className={areaDadosRel} style={{ overflow: 'auto' }} >
                <table className="table table-sm table-striped table-hover text-center" style={{ fontSize: '15px' }}>
                    <thead>
                        <tr>
                            <th scope="col">N°</th>
                            <th className="text-left" scope="col"> <span className="ml-5"> POSTO / GRADUAÇÃO</span></th>
                            <th className="text-left" scope="col"> <span className="ml-5"> NOME</span></th>
                            <th className="text-left" scope="col">NASCIMENTO</th>
                            <th className="text-left" scope="col">TELEFONE</th>
                            <th className="text-left" scope="col">TELEFONE</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            arrayDados.map((socio) => {

                                //formatar da data
                                let dataNasc = (socio.dt_nasc).toString()
                                let dia, mes, ano
                                dia = dataNasc.substring(8, 10)
                                mes = dataNasc.substring(5, 7)
                                ano = dataNasc.substring(0, 4)
                                dataNasc = `${dia}/${mes}/${ano}`

                                //contador
                                let cont = arrayDados.findIndex((soc) => soc.id === socio.id) + 1

                                return (
                                    /*  NO SCRIPT ABAIXO USO O NF COMO PESQUISE DE ID */
                                    <tr data-toggle="modal" data-target="#exampleModal" key={socio.id}>
                                        <th id="contN" scope="row">{cont}</th>
                                        <td className="text-left"><span className="ml-5">{socio.graduacao}</span></td>
                                        <td className="text-left"><span className="ml-5">{socio.nome}</span></td>
                                        <td className="text-left">{dataNasc}</td>
                                        <td className="text-left">{socio.tel1}</td>
                                        <td className="text-left">{socio.tel2}</td>
                                    </tr>)
                            })
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
}
